import { Maybe } from "@figurepos/fgr-lib-business-logic/lib/common/types"

export const SUMMARY_AGENDA_MOUNTED = "SUMMARY_AGENDA_MOUNTED"

export const summaryAgendaMounted = () => ({
    type: SUMMARY_AGENDA_MOUNTED,
})

export const CLEAR_SUMMARY_DATA = "CLEAR_SUMMARY_DATA"

export const clearSummaryData = () => ({
    type: CLEAR_SUMMARY_DATA,
})

export const SUMMARY_SELECT_ASSIGNEES_CLICKED = "summary/selectAssignees/clicked"

export const summarySelectAssigneesClicked = (ids: Maybe<string[]>) => ({
    type: SUMMARY_SELECT_ASSIGNEES_CLICKED,
    payload: {
        ids: ids,
    },
})
